__turbopack_context__.v({
  "icon": "Gyk3qq_icon",
  "labels": "Gyk3qq_labels",
  "permissionsToggles": "Gyk3qq_permissionsToggles",
  "switchLabel": "Gyk3qq_switchLabel",
  "unselectButton": "Gyk3qq_unselectButton",
  "values": "Gyk3qq_values",
});
